













import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ListItem",
  props: {
    bottomShadow: { type: Boolean, default: true },
    height: { type: Number, default: 72 },
    autoHeight: { type: Boolean, default: false },
    minHeight: { type: Number },
  },
});
